// extracted by mini-css-extract-plugin
export default {"reserve":"ReserveSection_reserve__yhfFD","textWrapper":"ReserveSection_textWrapper__VdhvA","items":"ReserveSection_items__DcmH-","check":"ReserveSection_check__yLN8W"};